import { apolloQueryWrapper } from '@/shared/api';
import HOLTER_RR_HEATMAP_OVERVIEW from '@/entities/beat/api/queries/holterRrHeatMapOverview';
import type {
  HolterRrHeatMapOverviewQuery,
  HolterRrHeatMapOverviewQueryVariables,
} from '@/shared/api/generated/graphql';

export type HolterRrHeatMapOverview = {
  isSuccess: boolean;
  message: string;
  rrHeatMapOverview: { rrHeatMapType: string; reviewed: number; total: number }[];
};

// TODO(ts): typed as the HolterRrHeatMapOverviewFilter GraphQL input once its server-side shape is documented
/**
 * Loads the aggregate RR heat-map overview for a study. Runs the holterRrHeatMapOverview query and returns its rrHeatMapOverview payload, throwing the server message when isSuccess is false.
 *
 * @param filter - GraphQL filter narrowing the overview to a study and time range.
 * @param key - Cancellation key identifying this request.
 * @param isUsingCache - When true, lets the wrapper serve a cached result.
 * @param needCancel - Whether an in-flight request under the same key is cancelled first.
 * @returns A promise resolving to the RR heat-map overview.
 */
const fetchHolterRrHeatMapOverview = async (
  filter: any,
  key?: string | null,
  isUsingCache = false,
  needCancel = true,
) => {
  const result = await apolloQueryWrapper<
    HolterRrHeatMapOverviewQuery,
    HolterRrHeatMapOverviewQueryVariables
  >({
    options: {
      query: HOLTER_RR_HEATMAP_OVERVIEW,
      variables: {
        filter,
      },
    },
    isUsingCache,
    key,
    needCancel,
  });
  const { data } = result;
  const { holterRrHeatMapOverview } = data;
  if (holterRrHeatMapOverview?.isSuccess) {
    return holterRrHeatMapOverview.rrHeatMapOverview;
  }
  throw new Error(holterRrHeatMapOverview.message);
};

export default fetchHolterRrHeatMapOverview;
